<div class="empty-record">
  <!-- <img src="assets/image/no-record.png" alt="" *ngIf="!disableImage" /> -->
  <div class="title-f">{{ "common.noRecordFound" | translate }}</div>
  <div class="desc-f" *ngIf="!disableSubTitle">Add a new record now!</div>
</div>
